import * as React from 'react';
import {
  Dimensions,
  EmitterSubscription,
  Keyboard,
  NativeScrollEvent,
  Platform,
  RefreshControlProps,
  View
} from 'react-native';
import {
  withSafeAreaInsets,
  WithSafeAreaInsetsProps
} from 'react-native-safe-area-context';
import {
  Header,
  KeyboardAvoidingView,
  StatusBar
} from 'secullum-react-native-ui';
import { isEdgeToEdge } from '../../shared/modules/deviceInfo';

interface Props {
  keyboardAvoidingViewRef?: React.RefObject<KeyboardAvoidingView | null>;
  refreshControl?: React.ReactElement<RefreshControlProps>;
  scrollEnabled?: boolean;
  onScroll?: (e: NativeScrollEvent) => void;
  children?: React.ReactNode;
}

interface State {
  keyboardShow: boolean;
}

class ViewPrincipal extends React.Component<
  Props & WithSafeAreaInsetsProps,
  State
> {
  static defaultProps = {
    scrollEnabled: true
  };

  state: State = {
    keyboardShow: false
  };

  screenChangeDimensionsSubscription: EmitterSubscription | undefined;
  keyboardDidShowSubscription?: EmitterSubscription | undefined;
  keyboardDidHideSubscription?: EmitterSubscription | undefined;

  componentDidMount() {
    this.screenChangeDimensionsSubscription = Dimensions.addEventListener(
      'change',
      this.handleDimensionsChange
    );
    if (Platform.OS === 'ios') {
      this.keyboardDidShowSubscription = Keyboard.addListener(
        'keyboardWillShow',
        e => this.handleKeyboardShow(e)
      );

      this.keyboardDidHideSubscription = Keyboard.addListener(
        'keyboardWillHide',
        this.handleKeyboardHide
      );
    }
  }

  componentWillUnmount() {
    this.screenChangeDimensionsSubscription!.remove();

    if (Platform.OS === 'ios') {
      this.keyboardDidShowSubscription!.remove();
      this.keyboardDidHideSubscription!.remove();
    }
  }

  handleDimensionsChange = () => {
    this.forceUpdate();
  };

  handleKeyboardShow = (e: any) => {
    this.setState({ keyboardShow: true });
  };

  handleKeyboardHide = () => {
    this.setState({
      keyboardShow: false
    });
  };

  render() {
    const {
      keyboardAvoidingViewRef,
      refreshControl,
      children,
      scrollEnabled,
      onScroll
    } = this.props;
    const { keyboardShow } = this.state;

    const { top = 0, bottom = 0 } = this.props.insets ?? {};

    return (
      // ATENÇÃO!
      // O código pra fazer o teclado não ficar por cima dos campos é bem delicado.
      // Se você precisar mexer aqui, lembrar de testar, no mínimo:
      // * Android pelo APK (o comportamento no APK é diferente do Expo Client)
      // * iOS
      // * Abrir um campo no início do scroll da tela (ex: endereço dados cadastrais)
      // * Abrir um campo bem no final da tela (ex: naturalidade em dados cadastrais,
      //   testar com o campo bem no final do scroll, sem os botões salvar e cancelar
      //   aparecendo, e também com os botões aparecendo)
      // * Abrir campos no meio da tela, e verificar se só dá scroll quando o
      //   campo ficaria abaixo do teclado
      // * Não pode ficar um espaço vazio no final do scroll
      <KeyboardAvoidingView
        extraFieldHeight={16}
        extraWindowHeight={Header.height + StatusBar.height}
        refreshControl={refreshControl}
        ref={keyboardAvoidingViewRef}
        scrollEnabled={scrollEnabled}
        onScroll={onScroll}
        keyBoardShow={keyboardShow}
      >
        {({ availableHeight }) => (
          <View
            style={{
              padding: 16,
              // Sec-issues#11635: Ao atualizar para o Expo 53, foi visto que Dimensions.get('window').height (que é usado internamente pela lib)
              // está retornando o tamanho total da tela no Android 15, afim de não mexer na secullum-react-native-ui,
              // realizamos o desconto das 'bordas' nesse momento
              minHeight: isEdgeToEdge()
                ? availableHeight - top - bottom
                : availableHeight
            }}
          >
            {children}
          </View>
        )}
      </KeyboardAvoidingView>
    );
  }
}

export default withSafeAreaInsets(ViewPrincipal);
